import { render, staticRenderFns } from "./ModalFeedback.vue?vue&type=template&id=5ecf3927&"
import script from "./ModalFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports